// extracted by mini-css-extract-plugin
export var container = "_f2-0";
export var outlet = "_f2-1";
export var outletEnter = "_f2-2";
export var outletEnterActive = "_f2-3";
export var outletExit = "_f2-4";
export var outletExitActive = "_f2-5";